import type { CSSProperties } from "react";

/**
 * Sprint 14c — `[Restricted]` placeholder chip.
 *
 * Rendered wherever a cross-reference (mention, FK chip, entities frontmatter,
 * back-reference) points at a node the current user can't access. Reveals only
 * that *something* restricted is referenced — no name, id, or type — so refs
 * can't be enumerated. Non-interactive by design.
 */
export function RestrictedChip({ compact = false }: { compact?: boolean }) {
  const style: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    background: "var(--color-background-secondary)",
    color: "var(--color-text-tertiary)",
    padding: compact ? "1px 6px" : "var(--kuvio-pill-padding)",
    borderRadius: "var(--kuvio-pill-radius)",
    fontSize: 11,
    fontWeight: 400,
    fontFamily: "var(--font-sans)",
    lineHeight: 1.4,
    border: "0.5px dashed var(--color-border-secondary, var(--color-text-tertiary))",
    cursor: "default",
    userSelect: "none",
  };
  return (
    <span style={style} title="Restricted — you don't have access to this item">
      <i className="ti ti-lock" style={{ fontSize: 10, verticalAlign: -1 }} aria-hidden="true" />
      Restricted
    </span>
  );
}
